var map = {
	"./diannao0.png": "al5J",
	"./diannao1.png": "QOLB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z77j";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/diannao.*\.png$
// module id = Z77j
// module chunks = 3